import { DomUtil } from "./dom-util";

export class ObjectUtil {

    public static deepClone(obj: any): any {
        if (obj === null || typeof obj !== "object") {
            return obj;
        }

        const clone = Array.isArray(obj) ? [] : {};

        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                clone[key] = this.deepClone(obj[key]);
            }
        }

        return clone;
    }

    public static deepReplaceIds<Type>(obj: Type): Type {
        if (Array.isArray(obj)) {
            return obj.map((item: any) => this.deepReplaceIds(item)) as Type;
        }

        if (typeof obj === "object" && obj !== null) {
            const newObj: any = {} as Type;

            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    if (key === "id" && this.shouldBeReplaced(obj[key] as string)) {
                        newObj[key] = DomUtil.generateElementId() as any;
                    } else {
                        newObj[key] = this.deepReplaceIds(obj[key]);
                    }
                }
            }

            return newObj;
        }

        return obj;
    }

    public static deepEqualExceptFavorite(oldData: any, currentData: any): boolean {
        if (oldData === currentData) {
            return true;
        }

        if (typeof oldData !== typeof currentData) {
            return false;
        }

        if (typeof oldData !== "object" || oldData === null || currentData === null) {
            return false;
        }

        const keysOld = Object.keys(oldData);
        const keysCurrent = Object.keys(currentData);

        if (this.countKeysExceptFavorite(oldData) !== this.countKeysExceptFavorite(currentData)) {
            return false;
        }

        for (const key of keysOld) {
            if (key === "favorite") {
                continue;
            }
            if (!keysCurrent.includes(key) || !this.deepEqualExceptFavorite(oldData[key], currentData[key])) {
                return false;
            }
        }

        return true;
    }

    private static shouldBeReplaced(id: string): boolean {
        const idRegex = new RegExp(/^pb-[a-z0-9]{5}/);
        return idRegex.test(id);
    }

    private static countKeysExceptFavorite(data: any): number {
        const keysAll = Object.keys(data);
        let keysNumber = 0;
        for (const key of keysAll) {
            if (key === "favorite") {
                continue;
            }
            keysNumber++;
        }

        return keysNumber;
    }

}